// Library Imports
import axios from 'axios';
import { persistor, store } from './store';
import { logout } from './features/loginUser/loginUserSlice';

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

export const setAuthToken = (token: any) => {
  if (token) {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axiosInstance.defaults.headers.common['Authorization'];
  }

  // Response Interceptor
  axiosInstance.interceptors.response.use(
    function (config) {
      return config;
    },
    function (error) {
      if (error?.response?.status === 401) {
        const dispatch = store.dispatch as any;
        dispatch(logout());
        persistor.purge();
      }
      return Promise.reject(error);
    }
  );
};

export default axiosInstance;
